const router = {
  state: {
    echartItem: null
  },
  getters: {
    GetName (state) {
      return state.name
    }
  },
  mutations: {
    SET_CHARTITEM (state, value) {
      console.log(this)
      this.commit('setOffEchartItem', value)
      state.echartItem = value
    },
    setOffEchartItem (state, value) {
      console.log('setOffEchartItem')
      let chart = state.echartItem
      if (!chart || state.echartItem === value) { return }
      chart.dispatchAction({
        type: 'downplay',
        seriesIndex: 0
      })
      chart.dispatchAction({
        type: 'highlight',
        seriesIndex: 0
      })
      chart.dispatchAction({
        type: 'hideTip'
      })
      chart.dispatchAction({
        type: 'unselect'
      })
      chart.dispatchAction({
        type: 'updateAxisPointer',
        currTrigger: 'leave'
      })
    }
  },
  actions: {
  }
}

export default router
